import createIcon from '../../createIcon';

/**
 * @component @name TrendingUp
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYgNkwxOC4yOSA4LjI5TDEzLjQxIDEzLjE3TDkuNDEgOS4xN0wyIDE2LjU5TDMuNDEgMThMOS40MSAxMkwxMy40MSAxNkwxOS43MSA5LjcxTDIyIDEyVjZIMTZaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const TrendingUp = createIcon('TrendingUp', [
  [
    'path',
    {
      d: 'M16 6L18.29 8.29L13.41 13.17L9.41 9.17L2 16.59L3.41 18L9.41 12L13.41 16L19.71 9.71L22 12V6H16Z',
      key: 'b1qlob',
    },
  ],
]);

export default TrendingUp;
